/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a leap second, and does it affect these conversions?`)
};

const es_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es un segundo intercalado y afecta estas conversiones?`)
};

const de_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine Schaltsekunde, und beeinflusst sie diese Umrechnungen?`)
};

const nl_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een schrikkelseconde en beïnvloedt het deze conversies?`)
};

const fr_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'une seconde intercalaire, et affecte-t-elle ces conversions ?`)
};

const it_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un secondo intercalare e influisce su queste conversioni?`)
};

const pt_br2_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um segundo bissexto e afeta essas conversões?`)
};

const pt_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um segundo bissexto, e afecta estas conversões?`)
};

const ja_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`うるう秒とは何で、これらの変換に影響しますか?`)
};

const zh_uc_time_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq3_q", locale)
	if (locale === "en") return en_uc_time_faq3_q(inputs)
	if (locale === "es") return es_uc_time_faq3_q(inputs)
	if (locale === "de") return de_uc_time_faq3_q(inputs)
	if (locale === "nl") return nl_uc_time_faq3_q(inputs)
	if (locale === "fr") return fr_uc_time_faq3_q(inputs)
	if (locale === "it") return it_uc_time_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq3_q(inputs)
	if (locale === "pt") return pt_uc_time_faq3_q(inputs)
	if (locale === "ja") return ja_uc_time_faq3_q(inputs)
	return zh_uc_time_faq3_q(inputs)
};